import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
/* eslint-disable @typescript-eslint/no-empty-function */
import { PropsWithChildren } from 'react';
import { RouterProvider, createMemoryRouter } from 'react-router-dom';

import { AuthContext, LocaleProvider, type LanguageKey } from '../context';
import { User } from '../services';
import type { IndexPermissions } from '../services/service-trips-api/types/user-v2';
import { Translations } from '../utils';

type TestProviderProps = {
  logout?: () => void;
  refreshUser?: () => Promise<void>;
  isAuthenticated?: boolean;
  user?: User;
  lastLogin?: string | null;
  translations?: Translations;
  defaultLanguage?: LanguageKey;
  indexPermissions?: IndexPermissions;
  isSuperUser?: boolean;
};

export const TestProvider = ({
  logout = () => {},
  refreshUser = () => Promise.resolve(),
  isAuthenticated = true,
  indexPermissions = undefined,
  isSuperUser = false,
  user = {
    id: '12345',
    // usertype: 8,
    // customerID: 0,
    // companyNo: 2,
    email: 'testy@cabonline.com',
    // username: 'testy.mctest',
    // password: '123qweasd!',
    // freeReferenceID: true,
    // active: true,
    firstName: 'Testy',
    lastName: 'McTest',
    // freeProjectID: true,
    // language: '',
    // phone: '031321654',
    // mobile: '',
    // agreementID: 125,
    // projectID: '',
    // customerRefNo: '',
    comment: '',
    // passwordExpirationDate: 0,
    // persons: [],
    agreements: [
      {
        id: 125,
        name: 'TEST STOCKHOLMS STAD',
      },
    ] as User['agreements'],
    accounts: [],
    addresses: [],
    // rights: {},
  } as unknown as User,
  lastLogin = undefined,
  translations = {},
  defaultLanguage,
  children,
}: PropsWithChildren<TestProviderProps>) => {
  const queryClient = new QueryClient();
  const router = createMemoryRouter([
    {
      path: '/',
      element: children,
      loader: () => {
        return {
          name: 'test',
        };
      },
    },
  ]);

  return (
    <AuthContext.Provider
      value={{
        generateLoginUri: () =>
          Promise.resolve('http://localhost:3000/sign-in'),
        verifyCode: (code: string) => Promise.resolve(),
        logout,
        setCurityConfig: () => {},
        refreshUser,
        isAuthenticated,
        indexPermissions,
        isSuperUser,
        roles: user?.roles ?? [],
        lastLogin,
        identity: user
          ? {
              sub: `test-user-${user.id}`,
              firstName: user.firstName ?? '',
              lastName: user.lastName ?? '',
              email: user.email ?? '',
              displayName:
                user.displayName ??
                `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
              roles: user.roles ?? [],
            }
          : null,
      }}
    >
      <LocaleProvider
        translations={translations}
        defaultLanguage={defaultLanguage}
      >
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </LocaleProvider>
    </AuthContext.Provider>
  );
};
